import { render, staticRenderFns } from "./project_stats.vue?vue&type=template&id=da44949a&scoped=true&"
import script from "./project_stats.vue?vue&type=script&lang=ts&"
export * from "./project_stats.vue?vue&type=script&lang=ts&"
import style0 from "./project_stats.vue?vue&type=style&index=0&id=da44949a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44949a",
  null
  
)

export default component.exports